import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { InfectionStatusType } from '@mona/models';
import { EncountersActions } from '@mona/pdms/data-access-encounters';
import { InfectionStatusState } from '../../entities';
import { InfectionStatusActions } from '../actions';

export const infectionStatusAdapter: EntityAdapter<InfectionStatusType> = createEntityAdapter<InfectionStatusType>();

export const initialState: InfectionStatusState = infectionStatusAdapter.getInitialState({
    error: null,
    isLoading: false,
});

export const infectionStatusReducer = createReducer(
    initialState,
    on(InfectionStatusActions.loadInfectionStatus, state => ({ ...state, isLoading: true })),
    on(InfectionStatusActions.loadInfectionStatusSuccess, (state, { data }) =>
        // Use upsertMany instead of setAll so optimistic local entries (added/updated between
        // dispatching `loadInfectionStatus` and the response arriving, or by a WS push that
        // landed before the GET completed) are not wiped out. Deletions propagate via the
        // dedicated `addInfectionStatusChanges` action (WS push).
        infectionStatusAdapter.upsertMany(data, {
            ...state,
            error: null,
            isLoading: false,
        }),
    ),
    on(InfectionStatusActions.loadInfectionStatusFailure, (state, { error }) => ({
        ...state,
        error,
        isLoading: false,
    })),
    on(InfectionStatusActions.loadInfectionStatusCancelled, state => ({
        ...state,
        isLoading: false,
        error: null,
    })),
    on(InfectionStatusActions.updateInfectionStatus, (state, action) =>
        infectionStatusAdapter.updateMany(action.update, state),
    ),
    on(InfectionStatusActions.upsertInfectionStatus, (state, action) =>
        infectionStatusAdapter.upsertMany(action.data, state),
    ),
    on(InfectionStatusActions.removeInfectionStatus, (state, { ids }) => infectionStatusAdapter.removeMany(ids, state)),
    /**
     * Defensive reset for the MD-9750 stuck-spinner family.
     */
    on(InfectionStatusActions.clearInfectionStatus, EncountersActions.clearEncounter, state =>
        infectionStatusAdapter.removeAll({
            ...state,
            isLoading: false,
            error: null,
        }),
    ),
    on(InfectionStatusActions.addInfectionStatusChanges, (state, { toRemoveIds, toUpdateEntities }) => {
        const newState = infectionStatusAdapter.removeMany(toRemoveIds, state);

        return infectionStatusAdapter.upsertMany(toUpdateEntities, newState);
    }),
);
